import {gql} from "@irati/utils/gql"

const mutation = gql`
  mutation UpdateServiceFeesTiers($tiers: [TiersInput!]!) {
    updateServiceFeesTiers(tiers: $tiers)
  }
`

export default mutation
